import {
  AppointmentBookToStatusMappingHandler,
  IBaseAppointmentBook,
} from '../../../mappings/appointment-book-to-status';
import {
  D4WAppointmentBook,
  ID4WAppointmentBook,
  PatientAppointmentBookSourceEntity,
} from '../../source/entities/appointment-book';

export class D4WAppointmentBookToStatusMappingHandler extends AppointmentBookToStatusMappingHandler<
  D4WAppointmentBook,
  PatientAppointmentBookSourceEntity
> {
  sourceEntity = new PatientAppointmentBookSourceEntity();

  translateFn(record: ID4WAppointmentBook): IBaseAppointmentBook {
    return record;
  }
}
